import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material';
import { isTokenValid, removeToken } from '../../utils/Auth';
import { sharedStyles } from '../../utils/Style';

const DummyScrollButton = () => <></>;

export type AccountTab =
  | 'panel'
  | 'profile'
  | 'orders'
  | 'refunds'
  | 'address'
  | 'password'
  | 'logout';

const tabNames: Record<AccountTab, string> = {
  panel: 'Panel',
  profile: 'Profil',
  orders: 'Siparişler',
  refunds: 'İadeler',
  address: 'Adresler',
  password: 'Şifre',
  logout: 'Çıkış',
};

type AccountNavbarProps = {
  selectedTab: AccountTab;
};

export const AccountNavbar = ({ selectedTab }: AccountNavbarProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isTokenValid()) {
      navigate('/giris-yap');
    }
  }, []);

  const handleChange = useCallback((newValue: AccountTab) => {
    switch (newValue) {
      case 'panel': {
        navigate('/hesabim');
        break;
      }
      case 'profile': {
        navigate('/hesabim/profil-duzenle');
        break;
      }
      case 'orders': {
        navigate('/hesabim/siparislerim');
        break;
      }
      case 'refunds': {
        navigate('/hesabim/iadelerim');
        break;
      }
      case 'address': {
        navigate('/hesabim/adres');
        break;
      }
      case 'password': {
        navigate('/hesabim/sifre');
        break;
      }
      case 'logout': {
        removeToken();
        navigate('/');
        break;
      }
      default: {
        navigate('/hesabim');
        break;
      }
    }
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Tabs
        variant='scrollable'
        value={selectedTab}
        onChange={(_, value) => handleChange(value)}
        ScrollButtonComponent={DummyScrollButton}
      >
        {Object.entries(tabNames).map(([tab, name]) => (
          <Tab
            key={tab}
            value={tab}
            label={<Typography sx={sharedStyles.tabLabel}>{name}</Typography>}
          />
        ))}
      </Tabs>

      <Divider />
    </Box>
  );
};
